<template>
  <div>
    <CRow>
      <CCol col="12" md="8">
        <CCard>
          <CCardHeader>
            <div class="d-flex align-items-center header-actions">
              <strong>پروفایل</strong>

            </div>
          </CCardHeader>
          <CCardBody>
            <CCardBody>
              <CRow>
                <CCol col="12">
                  <CInput
                      v-model="name"
                      :label="$t('full_name')"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol col="12">
                  <CInput v-if="$i18n.locale=='fa'"
                          v-model="mobile"
                          :label="$t('mobile_no')"
                          :placeholder="$t('mobile_no')"
                  />
                  <CInput v-else
                          v-model="email"
                          :label="$t('email')"
                          :placeholder="$t('email')"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol col="12">
                  <CInput
                      v-model="password"
                      :label="$t('password')"
                      :placeholder="status_form==0 ? $t('password') : '*****'"
                  />
                </CCol>
                <CCol col="12">
                  <ImageSelector :label="$t('image')"
                                 :media_id.sync="file"
                                 default_archive="site"
                                 :preview-image="previewImage"
                  />
                </CCol>
              </CRow>
            </CCardBody>
            <div >
              <CButton
                       @click="insert_data()"
                       class="mr-1"
                       size="sm" color="warning">ویرایش اطلاعات</CButton>

            </div>
          </CCardBody>
        </CCard>

      </CCol>

    </CRow>

    <!-- Modal for Add/Edit User -->

  </div>

</template>

<script>
import axios from "axios";
import {bus} from '../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,

      name: '',
      email: '',
      mobile: '',
      password: '',
      selected_group: 0,
      file: [],
      previewImage: null,
      description: '',

      collapseDuration: 0,
      status_form: 0,
      showUserModal: false
    }
  },
  components: {},
  mounted() {

    this.get_admins();

  }, watch: {

  },
  methods: {

    editDetails(item) {
      this.name = item.name
      this.email = item.email
      this.mobile = item.phone
      // this.password = item.password
      this.selected_group = item.role_group ? item.role_group.group_id : 0
      this.file[0] = item.image_id
      this.status_form = item.id
      this.previewImage = item.image || null
      this.showUserModal = true;
    },
    cancel_form() {
      this.name = ''
      this.email = ''
      this.mobile = ''
      this.password = ''
      this.selected_group = 0
      this.status_form = 0
      this.previewImage = null
      this.file = []
    },
    insert_data() {


      let self = this;
      const formData = new FormData()
      let url;

        url = "/api/admin/user/update_my_profile_admin";
        formData.append('id', this.status_form)
      this.password = this.toEnglishDigits(this.password)

      formData.append('image', this.file[0]);
      formData.append('name', this.name);
      formData.append('mobile', this.mobile);
      formData.append('email', this.email);
      formData.append('password', this.password);
      formData.append('role_group', this.selected_group);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {
          self.cancel_form();
          self.showUserModal = false;
          self.get_admins()
        }
      }).catch(function (error) {

        console.log(error);
      });

    },
    get_admins() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/user/get_my_profile', formData, {}).then(function (response) {
self.editDetails(response.data)

      })
          .catch(function (error) {

            console.log(error);
          });

    },


  }
}


</script>

<style scoped>
.header-actions {
  width: 100%;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.header-actions strong {
  order: 2;
}

.add-user-btn {
  order: 1;
}

.user-modal :deep(.modal-dialog) {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
  margin: 0.5rem auto;
}

.user-modal :deep(.modal-content) {
  margin: auto;
}

@media (max-width: 991px) {
  .user-modal :deep(.modal-dialog) {
    min-height: calc(100% - 3.5rem);
    margin: 1.75rem auto;
  }
}
</style>
